<template>
  <v-list dense three-line class="transparent">
    <template v-for="comment in comments">
      <v-list-item
        :key="comment.id"
        class="list__tile--free-height"
        :color="colour(comment)"
        v-if="showDetails(comment)"
      >
        <v-flex xs12>
          <v-layout column fill-height my-2>
            <v-flex>
              <div style="font-size:16px">{{ comment.author.name }}</div>
            </v-flex>
            <v-flex>
              <v-layout justify-space-between>
                <div class="text--secondary">Regarding: {{ comment.subject.name }}</div>
                <div class="text--secondary">{{ comment.created_at | moment('calendar') }}</div>
              </v-layout>
            </v-flex>
            <v-flex>
              <v-layout justify-space-between>
                <div class="text--primary">{{ comment.text }}</div>
                <div class="text--secondary" v-if="PlatformUser">
                  <v-icon class="mr-1" v-if="comment.subject.type === 'Business'" color="light-grey">fa-user</v-icon>
                  <v-icon class="mr-1" v-if="comment.subject.type === 'Referral'" color="light-grey"
                    >fa-people-carry</v-icon
                  >
                  <v-icon class="mr-1" v-if="comment.subject.type === 'Enquiry'" color="light-grey">fa-coins</v-icon>
                  <v-icon v-if="comment.privacy === 'internal'" color="red">fa-lock-alt</v-icon>
                  <v-icon v-else color="accent">fa-lock-open-alt</v-icon>
                </div>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  name: 'comment-list',
  computed: {
    ...mapGetters(['UserHasRole', 'AccountId', 'SelectedReferral', 'Enquiries', 'ReferralActivity']),
    comments() {
      return _.orderBy(this.ReferralActivity, ['created_at'], ['desc']);
    },
    PlatformUser() {
      return this.UserHasRole('Platform');
    }
  },
  methods: {
    colour(comment) {
      return comment.privacy === 'public' ? 'green darken-2' : 'red';
    },
    showDetails(comment) {
      if (this.PlatformUser || this.UserHasRole('Broker') || this.UserHasRole('Call Centre')) {
        return true;
      }

      return (
        comment.privacy === 'public' &&
        (comment.visibility.account_id === this.AccountId || comment.subject.type === 'Enquiry')
      );
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .list__tile {
  user-select: unset;
}

.list__tile--free-height {
  ::v-deep .list__tile {
    height: auto;
    min-height: 76px;
    padding: {
      top: 5px;
      bottom: 5px;
    }
    align-items: flex-start;
  }
}

::v-deep .list__tile__sub-title {
  -webkit-line-clamp: unset;
}

span.visibility {
  text-transform: uppercase;
}
</style>
